import { render, staticRenderFns } from "./targetSplitAdd.vue?vue&type=template&id=62b967e0&scoped=true"
import script from "./targetSplitAdd.vue?vue&type=script&lang=js"
export * from "./targetSplitAdd.vue?vue&type=script&lang=js"
import style0 from "./targetSplitAdd.vue?vue&type=style&index=0&id=62b967e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b967e0",
  null
  
)

export default component.exports